/**
 * Created by vadimdez on 20/01/2017.
 */
import { NgModule } from '@angular/core';
import {FilterByPropertyPipe} from './filter-by-property.pipe';

@NgModule({
  declarations: [FilterByPropertyPipe],
  exports: [FilterByPropertyPipe],
  providers: [FilterByPropertyPipe]
})
export class FilterByPropertyPipeModule {}



// WEBPACK FOOTER //
// /app/src/app/pipes/filter-by-property-pipe/filter-by-property-pipe.module.ts